<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col class="align-center">
        <v-row>
          <v-col cols="12" class="pb-0 headline text-uppercase">
            {{ $t('career.process.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('career.process.subtitle')}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        {{ $t('career.process.text')}}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-img src="@/assets/hr_flow.jpg"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Process',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
